import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Accordion } from '@base-ui/react';
import { Chevron } from '@commercial-website/icons';
import clsx from 'clsx';
import { m } from 'motion/react';
import React from 'react';
const imageVariants = {
    active: {
        opacity: 1,
        position: 'relative',
        display: 'block',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
    },
    inactive: {
        opacity: 0,
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
    },
};
const panelVariants = {
    open: {
        height: 'auto',
        opacity: 1,
        transition: {
            height: { duration: 0.15 },
            opacity: { duration: 0.2, delay: 0.05 },
        },
    },
    closed: {
        height: 0,
        opacity: 0,
        transition: {
            height: { duration: 0.15 },
            opacity: { duration: 0.1 },
        },
    },
};
export const TitleWithAccordion = ({ id, title, items, collapsible = true, dataTestId, }) => {
    const [activeIndex, setActiveIndex] = React.useState(0);
    const [openItems, setOpenItems] = React.useState(['item-0']);
    const hasImages = items.length > 0 && items.every((item) => Boolean(item.image));
    const handleValueChange = (newValue) => {
        if (!collapsible && newValue.length === 0)
            return;
        setOpenItems(newValue);
        if (newValue.length > 0) {
            const last = newValue[newValue.length - 1] ?? 'item-0';
            setActiveIndex(parseInt(last.replace('item-', ''), 10));
        }
    };
    return (_jsxs("section", { id: id, className: clsx('mx-auto grid w-full max-w-360 grid-cols-1 gap-6 px-6 py-10 sm:grid-cols-2 md:grid-cols-[0.9fr_1fr] md:gap-10 md:px-10 md:py-20 xl:gap-x-25 xl:gap-y-15 xl:px-25', hasImages ? 'items-center' : 'items-start'), "aria-label": hasImages ? title : undefined, "data-testid": dataTestId, children: [!hasImages && (_jsx("h2", { className: "text-dep-default font-dep-display text-dep-xl font-normal break-normal wrap-anywhere", children: title })), hasImages && (_jsx("div", { className: "relative perspective-[1000px] max-sm:order-1", children: items.map((item, i) => (_jsx(m.div, { initial: false, variants: imageVariants, animate: i === activeIndex ? 'active' : 'inactive', transition: { type: 'tween', duration: 0.5 }, children: _jsx("div", { className: "w-full", "aria-hidden": i !== activeIndex, children: item.image }) }, `${item.title}-${i}`))) })), _jsx(Accordion.Root, { value: openItems, onValueChange: handleValueChange, "data-testid": dataTestId ? `${dataTestId}-accordion-container` : undefined, children: items.map(({ title: itemTitle, body, icon }, i) => {
                    const itemValue = `item-${i}`;
                    const isOpen = openItems.includes(itemValue);
                    return (_jsxs(Accordion.Item, { value: itemValue, className: "border-dep-secondary not-last:border-b", children: [_jsx(Accordion.Header, { className: "m-0", children: _jsx(Accordion.Trigger, { id: `${itemValue}-trigger`, "aria-controls": `${itemValue}-panel`, className: "focus-visible:focus-ring-dep-thin rounded-dep-4 w-full cursor-pointer border-0 bg-transparent px-0 py-3 text-left text-inherit sm:py-4", children: _jsxs("span", { className: "grid w-full grid-cols-[1fr_auto] items-center gap-x-3", children: [_jsx("span", { className: "text-dep-default font-dep-display text-dep-sm font-normal break-normal wrap-anywhere", children: itemTitle }), _jsx(m.span, { animate: { rotate: isOpen ? 180 : 0 }, transition: { duration: 0.2, type: 'tween' }, className: "flex", children: _jsx(Chevron, { className: "size-3" }) })] }) }) }), _jsx(m.div, { id: `${itemValue}-panel`, ...(!isOpen ? { inert: '' } : {}), initial: false, animate: isOpen ? 'open' : 'closed', variants: panelVariants, className: "overflow-hidden", children: _jsx("div", { className: "py-3 sm:py-4", children: icon ? (_jsxs("div", { className: "grid grid-cols-[auto_1fr] items-center gap-x-4", children: [_jsx("div", { className: "size-10 shrink-0 max-sm:hidden", children: icon }), _jsx("div", { children: body })] })) : (body) }) })] }, itemValue));
                }) })] }));
};
